import { createAction } from 'redux-actions';

export const dialogChangeParentMapping = createAction('DIALOG_CHANGE_PARENT_MAPPING');
export const dialogLoadMappingsUsed = createAction('DIALOG_LOAD_MAPPINGS_USED');
